import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddTeamMember.css";
import { getUserId } from "../../utils/tokenUtils";
import UserProfileBox from "../userProfileBox/UserProfileBox"; // Adjust the import path
import { TeamMembersService } from "../../services/teamMembers/teamMembersService";
import { useToast } from "../../components/common/ToastManager/ToastContext";
import Loader from "../../components/common/Loader/Loader";
import TopBar from "../../components/TopBar/TopBar";
import { HelenService } from "../../services/helen/helenService";

const AddTeamMember = () => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = useState(false);

  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/team");
  };
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [position, setPosition] = useState("");
  const [userId] = useState(getUserId());

  const [bots, setBots] = useState<any[]>([]);
  const [selectedBot, setSelectedBot] = useState("");

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!firstName.trim()) newErrors.firstName = "First name is required";
    if (!lastName.trim()) newErrors.lastName = "Last name is required";

    if (!loginEmail.trim()) {
      newErrors.loginEmail = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(loginEmail)) {
      newErrors.loginEmail = "Invalid email format";
    }
    if (!selectedBot) newErrors.selectedBot = "Please assign a bot";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddMember = async () => {
    if (!validateForm()) return;

    // Null checks
    if (!firstName?.trim() || !lastName?.trim() || !loginEmail?.trim()) {
      showToast("Please fill in all required fields", "error");
      return;
    }

    if (!selectedBot) {
      showToast("Please select a bot", "error");
      return;
    }

    if (!userId) {
      showToast("User ID not found. Please try again.", "error");
      return;
    }

    const memberData = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      login_email: loginEmail.trim(),
      admin_user_id: userId,
      assigned_bot_id: selectedBot,
    };

    try {
      setIsLoading(true);
      const response = await TeamMembersService.addTeamMember(memberData);

      if (response?.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }

      showToast("Team member added successfully!", "success");
      setIsLoading(false);
      navigate("/team");
    } catch (error) {
      setIsLoading(false);
      const err = error as any;
      const msg =
        err?.response?.data?.message ||
        "Failed to add team member. Please try again.";
      showToast(msg, "error");
    }
  };

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const response = await HelenService.getNonAssignedBots();

        if (response.status === 200 && response.data?.userAssignedBots) {
          setBots(response.data.userAssignedBots); // assuming API returns { data: [...] }
        } else {
        }
      } catch (error) {
      }
    };

    fetchBots();
  }, []);

  if (isLoading) return <Loader inline />;

  return (
    <div className="dashboard-container">
      <TopBar />
      <div className="add-member-wrapper">
        <button className="back-link" onClick={handleCancel}>
          <img src="/images/editarrow.svg" alt="Back" className="back-icon" />
          <span>Back To My Team</span>
        </button>
        <h2 className="add-member-title">Add Team Member</h2>
        <div className="add-member-form-card">
          <div className="upload-photo-section">
            <div className="photo-circle">
              <img
                className="profile-image"
                src="/images/Profile.svg"
                alt="Upload"
              />
            </div>
          </div>

          <form className="form-grid">
            <div className="form-group">
              <label>
                First Name<span className="required"> *</span>
              </label>
              <input
                type="text"
                placeholder="Enter Details"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              {errors.firstName && (
                <span className="error-text">{errors.firstName}</span>
              )}
            </div>
            <div className="form-group">
              <label>
                Last Name<span className="required"> *</span>
              </label>
              <input
                type="text"
                placeholder="Enter Details"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && (
                <span className="error-text">{errors.lastName}</span>
              )}
            </div>
            <div className="form-group">
              <label>
                Email Id<span className="required"> *</span>
              </label>
              <input
                type="email"
                placeholder="Enter Details"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
              />
              {errors.loginEmail && (
                <span className="error-text">{errors.loginEmail}</span>
              )}
            </div>
            <div className="form-group">
              <label>
                Assign Helen<span className="required"> *</span>
              </label>
              <select
                value={selectedBot}
                onChange={(e) => setSelectedBot(e.target.value)}
              >
                <option value="">Select Helen</option>
                {bots.map((bot) => (
                  <option key={bot.id} value={bot.id}>
                    {bot?.helen_name ? bot.helen_name.charAt(0).toUpperCase() + bot.helen_name.slice(1).replace(/_/g, ' ') : 'Unknown'}
                  </option>
                ))}
              </select>
              {errors.selectedBot && (
                <span className="error-text">{errors.selectedBot}</span>
              )}
            </div>
          </form>

          <div className="form-buttons">
            <button className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="submit-button"
              type="button"
              onClick={handleAddMember}
            >
              Add Member
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTeamMember;
